/**
 * Vormtaal van de publieke site na de vernieuwing (docs/VORMGEVING.md).
 *
 * Ritme: elke sectie één toon, `bg-sand`, `bg-shell`, `bg-blush` of `bg-clay` (tekst `text-shell`).
 * Diepte uit klei en blush, nooit uit zwart; hoogstens één à twee klei-vlakken per pagina.
 * Contrast (AA, gecontroleerd): ink en muted op sand/shell/blush ≥ 4,9:1; shell op clay 5,6:1.
 * Op clay dus nooit `text-muted` of kleine `text-blush`; blush alleen voor grote koppen.
 * Scheidingslijnen altijd haarlijnen (`border-ink/15` of `border-line`), nooit zware inktlijnen.
 */

/** Sectiekop: groter en strakker dan voorheen (was text-4xl / 2.9rem). */
export const sectionHeading = 'font-display text-[2.6rem] font-light leading-[1.02] tracking-[-0.015em] sm:text-[3.4rem] lg:text-[4rem]'

/**
 * Paginakop (h1) op elke pagina: home, salon, protocollen, over, journal, contact.
 * Eén maat, zodat geen pagina harder roept dan de andere; groeit vloeiend tot ± 3,9rem.
 */
export const heroTitle =
  'text-balance font-display text-[2.2rem] font-light leading-[1.04] tracking-[-0.02em] text-ink sm:text-[3rem] lg:text-[clamp(2.75rem,3.5vw,3.9rem)]'

/** Kleinere afsluitkop (twijfel, al klant, salon): één stap onder de sectiekop. */
export const closingHeading = 'font-display text-[2.2rem] font-light leading-[1.05] sm:text-5xl'

/**
 * Mijn omgeving (docs/VORMGEVING.md §6): één kopmaat-reeks voor de hele portal.
 * `accountTitle` = de paginakop (h1), `accountHeading` = de kop van een blok (h2).
 */
export const accountTitle = 'font-display text-[2.2rem] font-light leading-[1.05] text-ink sm:text-[2.75rem]'
export const accountHeading = 'font-display text-[1.5rem] font-light leading-tight text-ink sm:text-[1.75rem]'

/**
 * Vastgezette delen (sticky) staan altijd net onder de header: de header verschijnt bij omhoog
 * scrollen en zet dan `--header-offset` op zijn hoogte (0 als hij weg is). Zo verdwijnt een
 * klachtenbalk of scène nooit onder de header. Zelfde duur als het in- en uitschuiven van de header.
 */
export const belowHeader = 'top-[var(--header-offset,0px)] transition-[top] duration-300 ease-soft motion-reduce:transition-none'

/** Klein regeltje boven een kop. */
export const eyebrowCls = 'text-[14px] tracking-[0.01em]'

/** Rustige tekstlink met pijl, in de kleur van de sectie; 44px hoog om te tikken. */
export const quietLink = 'inline-flex min-h-[44px] items-center gap-2 text-[15px] underline-offset-[6px] transition-colors duration-150 ease-soft hover:underline'
